@let loadDashboardStudyDetailsProgress = loadDashboardStudyDetailsProgress$ | async;
@let dashboardUser = dashboardUser$ | async;
@let dashboardStudyDetails = dashboardStudyDetails$ | async;
@let lastLoadDashboardStudyDetailsError = lastLoadDashboardStudyDetailsError$ | async;

<div class="dashboard-study">
  @switch (loadDashboardStudyDetailsProgress) {
    @case (progressStatuses.SUCCEED) {
      <div class="dashboard-study__controls">
        <app-dashboard-study-view-regions></app-dashboard-study-view-regions>
      </div>

      <div class="dashboard-study__details">
        @if (papayaScript.value()) {
          <div class="dashboard-study__viewer">
            <app-dashboard-study-viewer
              [dashboardUser]="dashboardUser"
              [dashboardStudy]="dashboardStudyDetails"
            ></app-dashboard-study-viewer>
          </div>
        }

        <div class="dashboard-study__data-zone">
          <app-dashboard-study-data-zone></app-dashboard-study-data-zone>
        </div>
      </div>
    }

    @default {
      Loading study
    }

    @case (progressStatuses.INTERRUPTED) {
      {{ lastLoadDashboardStudyDetailsError }}
    }
  }
</div>
